import qs from 'qs'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const ResetPasswordEmailSent = () => {
    const [email, setEmail] = useState('')
    const location = useLocation()
    const navigate = useNavigate()
    
    useEffect(() => {
        let email = qs.parse(location.search, { ignoreQueryPrefix: true }).email
        
        if (typeof email === 'string') {
            setEmail(email)
        }
    }, [location])
    
    return (
        <div className="flex flex-col items-center justify-center min-h-screen ">
            <div className="row justify-center items-center">
                <div className="w-full max-w-lg py-20 rounded-lg px-20 bg-sky-950 bg-opacity-30 mx-auto sm:my-8">
                    <div
                        style={{
                            marginBottom: '25px',
                            width: '80%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: '20px auto',
                        }}>
                        <img src="img/logo.png" width="100%" height="100%" alt="" />
                    </div>
                    <div className="text-center">
                        <h2 className="mb-2">Check your email</h2>
                        <p>We&apos;ve sent an email to <b>{email.toLowerCase()}</b> with password reset request.</p>
                        <p>Please click the link in the email to reset your password.</p>
                    </div>
                    <div
                        className="text-muted text-center mt-3 btn btn-outline btn-primary btn-block"
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate('/signin')}>
                        Back to Sign In
                    </div>
                </div>
            </div>
        </div>
    )
}
